import React, { useState } from "react";
import { FaWhatsapp, FaPhoneAlt, FaShoppingCart, FaTruck, FaLeaf, FaIndustry, FaWater, FaSeedling, FaRecycle, FaDollarSign } from "react-icons/fa";
import { Helmet } from "react-helmet";
import bulkLoadImg from "../../assets/cocImg/cocimg2.jpeg";

const BulkLoads = () => {
  const [showOptions, setShowOptions] = useState(false);
  const [activeTab, setActiveTab] = useState('description');

  const whatsappNumber = "+919492228585";
  const whatsappMessage = encodeURIComponent(
    "Hello Mr.Ramana Sir! I'm interested in ordering Bulk Loads of Coco Peat. Could you please provide more details?"
  );

  const handleOrderClick = () => {
    setShowOptions(!showOptions);
  };

  const benefits = [
    { icon: <FaDollarSign />, title: "Cost-Effective", desc: "Bulk pricing for large-scale agricultural projects" },
    { icon: <FaTruck />, title: "Bulk Delivery", desc: "Delivered via lorries, trucks, or tractors" },
    { icon: <FaLeaf />, title: "100% Organic", desc: "Natural and eco-friendly growing medium" },
    { icon: <FaWater />, title: "Water Retention", desc: "Superior water holding capacity" },
    { icon: <FaIndustry />, title: "Customizable", desc: "Mix ratios tailored to your requirements" },
    { icon: <FaRecycle />, title: "Eco-Friendly", desc: "Reduces packaging waste, sustainable solution" }
  ];

  const specifications = [
    { param: "Load Type", value: "Loose Bulk Coco Peat" },
    { param: "Transportation Modes", value: "Lorries, Trucks, Tractors" },
    { param: "Volume", value: "Varies based on truck/lorry capacity" },
    { param: "Material", value: "High-quality coco peat with customizable mixes" },
    { param: "Moisture Content", value: "10% - 15%" },
    { param: "EC Level", value: "Low EC: <0.5 mS/cm | High EC: >1.0 mS/cm" },
    { param: "pH Value", value: "5.5 - 6.5" }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Helmet>
        <title>Bulk Cocopeat Loads | Best Bulk Cocopeat Supplier & Exporter Andhra Pradesh, Anantapur</title>
        <meta name="description" content="Order bulk cocopeat loads from Tirumala Cocopeat, the best supplier and exporter in Andhra Pradesh, Anantapur. Premium quality bulk cocopeat for agriculture, greenhouses, hydroponics, and export. Delivered in trucks or lorries for large-scale farming needs." />
        <meta name="keywords" content="Tirumala Cocopeat, bulk cocopeat, bulk cocopeat supplier, bulk cocopeat exporter, best cocopeat in Andhra Pradesh, best cocopeat in Anantapur, cocopeat exporters, cocopeat suppliers, cocopeat manufacturers, cocopeat India, cocopeat for export, cocopeat exporters, exports, premium cocopeat, organic cocopeat, cocopeat business, cocopeat company, cocopeat for agriculture, cocopeat for horticulture, cocopeat for hydroponics, cocopeat for farming, cocopeat for nurseries, cocopeat for greenhouses, best cocopeat exporters, cocopeat global export, cocopeat delivery, cocopeat price, cocopeat online" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Bulk Cocopeat Loads | Best Bulk Cocopeat Supplier & Exporter Andhra Pradesh, Anantapur" />
        <meta property="og:description" content="Order bulk cocopeat loads from Tirumala Cocopeat, the best supplier and exporter in Andhra Pradesh, Anantapur. Premium quality bulk cocopeat for agriculture, greenhouses, hydroponics, and export. Delivered in trucks or lorries for large-scale farming needs." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://tirumalacocopeat.vercel.app/bulk-loads" />
      </Helmet>
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-green-50 to-green-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Product Image */}
            <div className="order-1 lg:order-1">
              <div className="relative bg-white rounded-2xl shadow-xl p-6 lg:p-8">
                <div className="absolute top-4 right-4 bg-green-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                  Bulk Load
                </div>
                <img
                  src={bulkLoadImg}
                  alt="Bulk Loads of Coco Peat"
                  className="w-full h-64 sm:h-80 lg:h-96 object-contain rounded-lg"
                />
              </div>
            </div>

            {/* Product Info */}
            <div className="order-2 lg:order-2 space-y-6">
              <div>
                <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                  Bulk Loads of Coco Peat
                </h1>
                <p className="text-lg sm:text-xl text-gray-600 leading-relaxed">
                  Premium quality bulk coco peat perfect for large-scale agriculture, hydroponics, and greenhouse farming. Cost-effective solution delivered directly to your farm.
                </p>
              </div>

              <div className="flex flex-wrap gap-2">
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
                  <FaLeaf className="mr-1" /> 100% Organic
                </span>
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                  <FaTruck className="mr-1" /> Bulk Delivery
                </span>
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-purple-100 text-purple-800">
                  <FaDollarSign className="mr-1" /> Cost-Effective
                </span>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-lg">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Key Features</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="flex items-center space-x-2">
                    <FaTruck className="text-green-600" />
                    <span className="text-gray-700">Truck Delivery</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <FaIndustry className="text-blue-600" />
                    <span className="text-gray-700">Industrial Scale</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <FaSeedling className="text-green-600" />
                    <span className="text-gray-700">pH 5.5-6.5</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <FaWater className="text-blue-600" />
                    <span className="text-gray-700">High Water Retention</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Product Details Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Tabs */}
        <div className="mb-8">
          <div className="flex flex-wrap gap-2 sm:gap-4 border-b border-gray-200">
            {['description', 'specifications', 'benefits'].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-4 py-2 text-sm sm:text-base font-medium capitalize transition-colors duration-200 border-b-2 ${
                  activeTab === tab
                    ? 'text-green-600 border-green-600'
                    : 'text-gray-500 border-transparent hover:text-green-600 hover:border-green-300'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content */}
        <div className="bg-white rounded-xl shadow-lg p-6 lg:p-8">
          {activeTab === 'description' && (
            <div className="space-y-6">
              <h2 className="text-2xl font-bold text-gray-900">Product Description</h2>
              <p className="text-gray-700 leading-relaxed text-lg">
                Bulk coco peat loads are ideal for large-scale agricultural projects, greenhouse operations, and soil conditioning. Delivered in loose form via lorries or tractors, they offer an efficient and cost-effective solution for your large-scale farming needs. The coco peat maintains excellent water retention, aeration, and organic properties that make it suitable for all your horticultural and agricultural applications.
              </p>
              <div className="bg-green-50 border-l-4 border-green-400 p-4">
                <p className="text-green-800 font-medium">
                  💡 Pro Tip: We offer customizable mix ratios of coconut coir, coco chips, and fiber to enhance soil fertility based on your specific requirements.
                </p>
              </div>
            </div>
          )}

          {activeTab === 'specifications' && (
            <div className="space-y-6">
              <h2 className="text-2xl font-bold text-gray-900">Technical Specifications</h2>
              <div className="overflow-x-auto">
                <table className="w-full border-collapse bg-white">
                  <thead>
                    <tr className="bg-green-50">
                      <th className="border border-gray-300 p-4 text-left font-semibold text-gray-900">Parameter</th>
                      <th className="border border-gray-300 p-4 text-left font-semibold text-gray-900">Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {specifications.map((spec, index) => (
                      <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                        <td className="border border-gray-300 p-4 font-medium text-gray-700">{spec.param}</td>
                        <td className="border border-gray-300 p-4 text-gray-700">{spec.value}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {activeTab === 'benefits' && (
            <div className="space-y-6">
              <h2 className="text-2xl font-bold text-gray-900">Key Benefits</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {benefits.map((benefit, index) => (
                  <div key={index} className="bg-gray-50 rounded-xl p-6 text-center hover:shadow-md transition-shadow duration-200">
                    <div className="text-3xl text-green-600 mb-3 flex justify-center">{benefit.icon}</div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">{benefit.title}</h3>
                    <p className="text-gray-600">{benefit.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-gradient-to-r from-green-600 to-green-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="text-center space-y-6">
            <h2 className="text-3xl sm:text-4xl font-bold">Ready for Large-Scale Agriculture?</h2>
            <p className="text-xl text-green-100 max-w-2xl mx-auto">
              Get premium bulk coco peat delivered directly to your farm. Perfect for greenhouse operations and large-scale farming projects.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-green-600 px-8 py-3 rounded-full font-semibold text-lg hover:bg-green-50 transition-all duration-300 flex items-center space-x-2 hover:scale-105"
              >
                <FaWhatsapp className="text-xl" />
                <span>Order via WhatsApp</span>
              </a>
              <a
                href={`tel:${whatsappNumber}`}
                className="bg-green-800 text-white px-8 py-3 rounded-full font-semibold text-lg hover:bg-green-900 transition-all duration-300 flex items-center space-x-2 hover:scale-105"
              >
                <FaPhoneAlt className="text-xl" />
                <span>Call Now</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Action Button */}
      <div
        onClick={handleOrderClick}
        className="fixed bottom-6 right-6 bg-green-600 text-white p-4 rounded-full shadow-xl hover:bg-green-700 transition-all duration-300 cursor-pointer hover:scale-110 z-50"
      >
        <FaShoppingCart className="text-xl" />
      </div>

      {/* Floating Options Menu */}
      <div
        className={`fixed bottom-24 right-6 transform transition-all duration-300 ease-in-out z-40 ${
          showOptions
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-10 pointer-events-none"
        }`}
      >
        <div className="bg-white shadow-xl rounded-xl p-4 space-y-3 border">
          <a
            href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-3 bg-green-600 text-white px-4 py-3 rounded-lg hover:bg-green-700 transition-all duration-300 hover:scale-105"
          >
            <FaWhatsapp className="text-xl" />
            <span className="font-medium">WhatsApp</span>
          </a>
          <a
            href={`tel:${whatsappNumber}`}
            className="flex items-center space-x-3 bg-blue-600 text-white px-4 py-3 rounded-lg hover:bg-blue-700 transition-all duration-300 hover:scale-105"
          >
            <FaPhoneAlt className="text-xl" />
            <span className="font-medium">Call Now</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default BulkLoads;